function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import MediaFrame from '../MediaFrame';

var LoadingItem = function LoadingItem(_ref) {
  var lineCount = _ref.lineCount;
  return /*#__PURE__*/React.createElement("div", {
    className: "psw-l-stack-left"
  }, /*#__PURE__*/React.createElement(MediaFrame, {
    aspectRatio: "1:1",
    className: "psw-loading-block psw-r-2"
  }), /*#__PURE__*/React.createElement("div", {
    className: "psw-p-5"
  }, _toConsumableArray(Array(lineCount)).map(function () {
    return /*#__PURE__*/React.createElement("br", null);
  })));
};

LoadingItem.defaultProps = {
  lineCount: 2
};
LoadingItem.propTypes = {
  /**
   * The number of lines expected for the loaded content. The number of lines here
   * saves the rough amount of space for the item
   */
  lineCount: PropTypes.number
};
export default LoadingItem;